import { render, staticRenderFns } from "./saleInfo.vue?vue&type=template&id=2b8b74de&scoped=true&"
import script from "./saleInfo.vue?vue&type=script&lang=js&"
export * from "./saleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b74de",
  null
  
)

export default component.exports